import { Injectable } from '@angular/core';

@Injectable({providedIn: 'root'})
export class CookieService {

	constructor() { }

	public cookieEnabled(): boolean {
		return navigator.cookieEnabled
			|| ('cookie' in document
				&& (document.cookie.length > 0
					||
					(document.cookie = 'test').indexOf.call(document.cookie, 'test') > -1)
			);
	}

}
